import React from 'react';
import { IconProps } from '.';

const SvgTablePivot = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M3.5 3.5v17h17v-17h-17ZM19 5H5v3.375h14V5Zm0 4.625H9.125v2.25H19v-2.25Zm-9.875 5.75v-2.25H19v2.25H9.125Zm0 1.25V19H19v-2.375H9.125Zm-1.25-7H5V19h2.875V9.625Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgTablePivot;
